import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Eye, FileText } from "lucide-react";
import { useTranslationApp } from "../../lib/i18next";
import { FORM, MODAL_VIEW_LEAD_FORM_TITLE } from "../../i18n/keysTranslations";
import {
  BORDER_GRAY_COLOR,
  GRAY_100,
  GRAY_200,
  GRAY_50,
  GRAY_500,
  PAPER_CONTRAST_TEXT,
} from "../../utils/colors";
import { BORDER_RADIUS } from "../../utils/constants";

// Selected lead form summary. With onClick it opens the read-only view of the
// form; without it (platforms with no viewer) it is a static summary card.
const InstantFormSummaryButton = ({ name, onClick }) => {
  const { t } = useTranslationApp();
  const viewLabel = t(MODAL_VIEW_LEAD_FORM_TITLE);
  const isClickable = typeof onClick === "function";

  return (
    <Box
      {...(isClickable && {
        component: "button",
        type: "button",
        onClick,
        title: viewLabel,
        "aria-label": `${viewLabel}: ${name}`,
      })}
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        p: 1.5,
        bgcolor: GRAY_50,
        borderRadius: BORDER_RADIUS,
        border: `1px solid ${BORDER_GRAY_COLOR}`,
        font: "inherit",
        textAlign: "left",
        ...(isClickable && {
          cursor: "pointer",
          transition: "background-color 0.2s ease",
          "&:hover": {
            bgcolor: GRAY_100,
          },
          "&:focus-visible": {
            outline: `2px solid ${PAPER_CONTRAST_TEXT}`,
            outlineOffset: "2px",
          },
        }),
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 32,
          height: 32,
          borderRadius: 1,
          bgcolor: GRAY_200,
          flexShrink: 0,
        }}
      >
        <FileText size={16} />
      </Box>
      <Box
        sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}
      >
        <Typography
          variant="caption"
          sx={{
            color: GRAY_500,
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          }}
        >
          {t(FORM)}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            color: PAPER_CONTRAST_TEXT,
            overflowWrap: "anywhere",
          }}
        >
          {name}
        </Typography>
      </Box>
      {isClickable && (
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
            color: GRAY_500,
            fontSize: "0.8125rem",
            fontWeight: 500,
            flexShrink: 0,
          }}
        >
          <Eye size={16} />
          {viewLabel}
        </Box>
      )}
    </Box>
  );
};

export default InstantFormSummaryButton;
